module.exports = __webpack_public_path__ + "static/GminaMielno-47168a56f77e0a722b363a5cae41374c.svg";